import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/o/$orgId/sessions')({
  loader: () => ({
    crumb: 'Sessions',
  }),
})
